// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2y4US","footer":"ChangeClinic_footer__2g2Jo"};